import { Link } from "react-router-dom";

import Icon from "@/common/images/icons/right_arrow.svg?react";

import "./SeeAllButton.scss";

export const SeeAllButton = (props: {
  link: string;
}) => {
  return (
    <Link to={props.link} className="seeAllButton">
    See All <Icon />
    </Link>
  );
};
